import template from '../../../../views/maileditor/availability.html';

export default class availabilityPanel {
    constructor() {
        return {
            template: template,
            replace: true,
            scope: {
                content: '=',
                active: '='
            },
            controller: ['$scope', '$element', '$attrs', '$rootScope', '$filter', (scope, element, attrs, $rootScope, $filter) => {

                scope.currentTab = 'lix';

                var lixColorCode = "#000000";
                var MAX_WORDCOUNT_PER_SENTENCE = 20;

                var statistics = {
                    lix: {
                        value: 0,
                        interpretation: ''
                    },
                    numWords: 0,
                    numSentences: 0,
                    numLongWords: 0,
                    avgSentenceLength: 0,
                    longWordRatio: 0,
                    exclamations: [],
                    ttr: 0,
                    ovix: 0,
                    ovr: 0
                };

                var interpretLixValue = (value) => {
                    if (value < 30) {
                        lixColorCode = "#05cc87";
                        statistics.generalAvailability = $filter('translate')('AVAILABILITY:GENERAL:VALUE_1');
                        return $filter('translate')('AVAILABILITY:LIX:VALUE_1');
                    } else if (value < 40) {
                        lixColorCode = "#05cc87";
                        statistics.generalAvailability = $filter('translate')('AVAILABILITY:GENERAL:VALUE_2');
                        return $filter('translate')('AVAILABILITY:LIX:VALUE_2');
                    } else if (value < 50) {
                        lixColorCode = "#B6B41B";
                        statistics.generalAvailability = $filter('translate')('AVAILABILITY:GENERAL:VALUE_3');
                        return $filter('translate')('AVAILABILITY:LIX:VALUE_3');
                    } else if (value < 60) {
                        lixColorCode = "#CDA94A";
                        statistics.generalAvailability = $filter('translate')('AVAILABILITY:GENERAL:VALUE_4');
                        return $filter('translate')('AVAILABILITY:LIX:VALUE_4');
                    } else {
                        lixColorCode = "#CD6D4A";
                        statistics.generalAvailability = $filter('translate')('AVAILABILITY:GENERAL:VALUE_5');
                        return $filter('translate')('AVAILABILITY:LIX:VALUE_5');
                    }
                };

                var getLongWords = (words) => {
                    var longWords = [];

                    angular.forEach(words, (word) => {
                        if (word.length > 6) {
                            longWords.push(word);
                        }
                    });

                    return longWords;
                };

                var getListOfWordsAndSentences = (elements) => {
                    var allWords = [];
                    var allSentences = [];
                    var exclamations = [];
                    var longSentences = [];
                    angular.forEach(elements, (element) => {
                        if ($(element).attr('style').indexOf('font-family') > -1) {
                            var text = $.trim($(element).text());
                            text = text.replace(/[\s]+/g, ' ');
                            if (text.length > 0) {
                                allWords = allWords.concat(text.split(/\s/));
                                var newSentences = text.split(/[\\.!\?•]\s/);
                                var delimiters = text.match(/[\\.!\?•]\s/g);
                                angular.forEach(newSentences, function(s, i) {
                                    var words = s.split(/\s/);

                                    if (delimiters && delimiters[i] != null) {
                                        s = s.concat(delimiters[i])
                                        delimiters[i] = $.trim(delimiters[i])
                                    }

                                    if ((delimiters && delimiters[i] == '!') || s.substring(s.length-1, s.length) == '!') { /* Exclamations */
                                        exclamations.push(s)
                                        var exclamationWord = $.trim(words[words.length-1])
                                        var highlightSpan = $(element).html().replace(exclamationWord, '<span class="exclamation">' + exclamationWord + '</span>')
                                        $(element).html(highlightSpan)
                                    }

                                    /* Long sentences */
                                    if (words.length > MAX_WORDCOUNT_PER_SENTENCE && words[0].substring(0,1) !== '%') {
                                        var html = $(element).html()
                                        var matches = html.replace(/&nbsp;/g, ' ').match(new RegExp($.trim(s)))

                                        if (matches != null) {
                                            longSentences.push(s)
                                            var startHtml = html.substring(0, matches.index)
                                            var endHtml = html.substring(matches.index + matches[0].length, html.length-1)
                                            var newHtml = startHtml + '<span class="longSentences">' + matches[0] + '</span>' + endHtml
                                            $(element).html(newHtml)
                                        }
                                    }
                                    allSentences = allSentences.concat(s)
                                })
                            }
                        }
                    });
                    return { words: allWords, sentences: allSentences, exclamations: exclamations, longSentences: longSentences }
                };

                var highLight = () => {
                    $('.highlight').removeClass('highlight')
                    if (scope.currentTab == 'longSentences') {
                        $('.longSentences').addClass('highlight')
                    } else if (scope.currentTab == 'exclamations') {
                        $('.exclamation').addClass('highlight')
                    }
                };

                scope.$watch('currentTab', () => {
                    highLight()
                });

                var analyze = (elements) => {
                    var res = getListOfWordsAndSentences(elements);
                    var types = _.uniq(res.words).length;
                    var tokens = statistics.numWords = res.words.length;
                    statistics.longSentences = res.longSentences;
                    statistics.numSentences = res.sentences.length;
                    statistics.exclamations = res.exclamations;
                    statistics.avgSentenceLength = parseFloat(statistics.numWords / statistics.numSentences);
                    statistics.avgSentenceLength = parseFloat(statistics.avgSentenceLength).toFixed(1);
                    statistics.longWords = getLongWords(res.words);
                    statistics.longWordRatio = (parseFloat(statistics.longWords.length / statistics.numWords) * 100).toFixed(1);
                    statistics.lix.value = (parseFloat(statistics.avgSentenceLength) + parseFloat(statistics.longWordRatio)).toFixed(1);
                    statistics.lix.interpretation = interpretLixValue(statistics.lix.value);
                    statistics.ovix = (Math.log(tokens)/Math.log(2-(Math.log(types)/Math.log(tokens)))).toFixed(1);
                    statistics.ttr = (parseFloat(types / tokens) * 100).toFixed(1);
                    statistics.ovr = (Math.log(types)/Math.log(tokens) * 100).toFixed(1);
                    $('.colored-bar').css('background', lixColorCode);
                    highLight();
                    return statistics
                };

                var analyzeContent = () => {
                    scope.numSentenceToShow = 3;
                    var tables = $('.responsive');

                    if (tables.length == 0) {
                        tables = $('table');
                    }

                    scope.statistics = analyze(tables.find($("[style]")));
                };

                $rootScope.$on('mailEditor.updateAnalysis', () => {
                    analyzeContent();
                });

                scope.$watch('active', (newVal) => {
                    if (newVal == 'availability') {
                        analyzeContent();
                    }
                });
            }]
        }
    }
}

